<template>
  <div id="timeTools">
    <Row>
      <Col span="16"
        ><p @click="openPicker(0)" v-show="motal == 0">
          {{ monthText }}<Icon type="ios-arrow-down" />
        </p>
        <p @click="openPicker(1)" v-show="motal == 1">
          {{ dayText }}<Icon type="ios-arrow-down" /></p
      ></Col>
      <Col span="8"
        ><ul id="dasdsc">
          <li :class="{ active: motal == 0 }" @click="selectMotal(0)">按月</li>
          <li :class="{ active: motal == 1 }" @click="selectMotal(1)">按天</li>
        </ul></Col
      >
    </Row>

    <mt-datetime-picker
      :startDate="allStart"
      :endDate="allEnd"
      ref="picker0"
      type="date"
      v-model="month"
      @confirm="searchMonth"
      class="lycol lycol2"
    ></mt-datetime-picker>
    <mt-datetime-picker
      :startDate="allStart"
      :endDate="allEnd"
      ref="picker1"
      type="date"
      v-model="date"
      @confirm="searchDay"
      class="lycol lycol3"
    ></mt-datetime-picker>
  </div>
</template>
<script>
var date = new Date();
var yyyy = date.getFullYear();
export default {
  data() {
    return {
      allStart: new Date(yyyy - 2, 0, 1),
      allEnd: new Date(Date.now()),
      timeObj: {},
      month: new Date(),
      monthText: "",
      date: new Date(),
      dayText: "",
      motal: 0,
    };
  },
  methods: {
    openPicker(t) {
      if (t == 0) {
        this.$refs.picker0.open();
        this.$refs.picker0.$el.getElementsByClassName(
          "picker-slot"
        )[2].style.display = "none";
      } else {
        this.$refs.picker1.open();
      }
    },
    selectMotal(t){
      this.motal=t;
      if (t==0) {
        this.searchMonth()
      }else{
        this.searchDay();
      }
    },
    searchMonth() {
      var y = this.month.getFullYear();
      var m = this.month.getMonth();
      var start = new Date(y, m, 1).getTime();
      var end = new Date(y, m + 1, 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.monthText = this.utils.time(this.month, "zhyymm");
      this.$emit("timeObj", this.timeObj);
    },
    searchDay() {
      var y = this.date.getFullYear();
      var m = this.date.getMonth();
      var d = this.date.getDate();
      var start = new Date(y, m, d).getTime();
      var end = new Date(y, m, d + 1).getTime() - 1000;
      this.timeObj = { start, end };
      this.dayText = this.utils.time(this.date, "zhyymmdd");
      this.$emit("timeObj", this.timeObj);
    },
  },
  mounted() {
    setTimeout(() => {
      this.searchMonth();
    }, 200);
  },
};
</script>
<style lang="">
#timeTools {
  padding: 0 10px;
  line-height: 30px;
}
#timeTools {
  padding: 0 10px;
  line-height: 30px;
}
#dasdsc {
  float: right;
}
#dasdsc li {
  display: inline-block;
  margin-left: 10px;
}
#dasdsc li.active {
  border-bottom: solid 1px #333;
}
</style>



// WEBPACK FOOTER //
// src/components/common/lyTime.vue